import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";

export class RESpinReelPartAnimator extends SpinReelPartAnimator {

    constructor(reelId: number) {
        super(reelId);
    }

    protected fadeOutSymbolBlur(): void {
        super.fadeOutSymbolBlur();
        //commented code to fix #193
        // if (WalkingWild.IS_FINAL_MULTIPLIER_MOVING) {
        //     for (let i = 0; i < this._symbolsToAnimate.length; i++) {
        //         //(this._symbolsToAnimate[i].symName != "M2" && this._symbolsToAnimate[i].symName != "M3") &&
        //         this._symbolsToAnimate[i].changeState({
        //             state: RomanEmpireGameConfig.instance.SYMBOL_STATES.noWin
        //         });
        //     }
        // }
    }
}